import { logistica_GUIA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { structureInfoState } from "../helpersRedux";

const initialState={
  guiasRecientesHome: new structureInfoState([] as logistica_GUIA[]) //nos trae las guias recientes en "/home"
}

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setGuiasRecientesHome: (state, action: PayloadAction<structureInfoState<logistica_GUIA[]>>) =>{
      state.guiasRecientesHome = action.payload
    }
}
});


export const {
  setGuiasRecientesHome
} =homeSlice.actions

export default homeSlice.reducer